module.exports = "/images/icon-arrow-down.svg?aba5cbae6e40747be58e2844fa0448d6";